export default __webpack_public_path__ + "static/media/loginbanner.5ec529d9.svg";